import { HoldingPage } from "@ecologi/react-components";
import { PlatformFeature } from "@ecologi/shared";
import { GiftingRedeemPage } from "../features";
import { withFeatureFlagGuard } from "../lib/auth/with-feature-flag-guard";

export async function getStaticProps() {
  return GiftingRedeemPage.prefetchData();
}

const GiftingRedeemPageComponent = withFeatureFlagGuard(
  GiftingRedeemPage,
  HoldingPage,
  {
    [PlatformFeature.GiftRedemption]: true,
  }
);

export default GiftingRedeemPageComponent;
